<template>
    <!-- Usa la pantalla de carga oficial (HyFLoader). Se mantienen las props
         de siempre para no tocar las páginas que ya lo usan:
         backdrop → pantalla completa; sin backdrop → bloque en la página;
         error → logo quieto, sin aviones, con el mensaje. -->
    <HyFLoader :variant="backdrop ? 'fullscreen' : 'inline'" :paused="error">
        <span v-if="message" v-html="message"></span>
    </HyFLoader>
</template>

<script>
import HyFLoader from '@/components/Loader/HyFLoader.vue';

export default {
    name: 'Loader',
    components: { HyFLoader },
    props: {
        message: {
            type: String,
            default: "",
            required: false
        },
        error: {
            type: Boolean,
            default: false
        },
        backdrop: {
            type: Boolean,
            default: false
        }
    }
}
</script>
